import reportError from 'airship/modules/report-error'
import {getAnalytics} from 'airship/modules/track'

/**
 * Track all page views and identify user groups.
 */
async function init(): Promise<void> {
  const analytics = getAnalytics()
  await analytics.tracks('URL', 'View', '', {url: window.location.href})
}

init().catch(reportError)
